const DEFAULT_SESSION = {
  searchQuery: '',
  selectedRows: [],
  selectedEnv: 'Prod',
  statusFilter: 'all',
};

let session = { ...DEFAULT_SESSION };

export const getMachineDetailsSession = () => session;

export const setMachineDetailsSession = (nextSession) => {
  session = {
    ...session,
    ...nextSession,
  };
};

export const clearMachineDetailsSession = () => {
  session = { ...DEFAULT_SESSION };
};
